
export const appReducer = (state, action) => {
  var nState = state;
  switch (action.type) {
    case 'SIGNIN':
      nState = Object.assign({}, state, {CurrentUser: action.data});
      localStorage.setItem("ScoreCardUserLoginTime", (new Date()).getTime().toString());
      localStorage.setItem("ScoreCardUser", JSON.stringify(nState))
      break;
    case 'QUICKSIGHT_URL': 
      nState = Object.assign({}, state, {QuickSightUrl: action.data});
      break;
    case 'LOGOUT':
      localStorage.removeItem("ScoreCardUserLoginTime");
      localStorage.removeItem("ScoreCardUser");
      nState = Object.assign({}, state, {CurrentUser: null, QuickSightUrl: null});
      break;
    default:
      return state;
  }

  return nState;
} 